<div class="cancel">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.ContactModal, langText.Header)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  @if (!isLoading ) {
<div>
    <div class="modal-body pt-0">
      <div><strong>{{localize(langSection.ContactModal, langText.ResponsibleUpsLocation)}}:</strong> {{contact?.customer ?? ''}}</div>
      <div><strong>{{localize(langSection.Term, langText.Phone)}}:</strong> {{contact?.telephoneNumber ?? ''}}</div>
      <div><strong>{{localize(langSection.Term, langText.Email)}}:</strong>&nbsp;<a href="mailto:{{contact?.email ?? ''}}">{{contact?.email ?? ''}}</a></div>
      <div class="hours-of-operation">
        <div class="label">{{localize(langSection.ContactModal, langText.HoursOfOperation)}}:<br>@if (hasHours) {
<span>({{localizeValue(langSection.TimeZones, contact?.timezoneName)}})</span>
}</div>
        <div class="hours">
          <div>{{localize(langSection.ContactModal, langText.Sunday)}}</div>
          <div>{{hours[0]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Monday)}}</div>
          <div>{{hours[1]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Tuesday)}}</div>
          <div>{{hours[2]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Wednesday)}}</div>
          <div>{{hours[3]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Thursday)}}</div>
          <div>{{hours[4]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Friday)}}</div>
          <div>{{hours[5]}}</div>
          <div>{{localize(langSection.ContactModal, langText.Saturday)}}</div>
          <div>{{hours[6]}}</div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button" class="btn btn-green" (click)="dismissModal()">{{localize(langSection.Term,
        langText.Continue)}}</button>
    </div>
  </div>
} @else {

  <div class="loading">
    {{localize(langSection.Term, langText.Loading)}}
  </div>

}
</div>
